import(/* webpackMode: "eager" */ "/app/apps/no-ga/src/app/_components/SideMenu/DesktopMenu.tsx");
import(/* webpackMode: "eager" */ "/app/apps/no-ga/src/app/_components/SideMenu/MobileMenu.tsx")